import React from 'react';
import HeroSection from '../components/HeroSection';
import Welcome from '../components/Welcome';
import OurStory from '../components/OurStory';
import WeddingDetails from '../components/WeddingDetails';
import Gallery from '../components/Gallery';
import Program from '../components/Program';
import RSVPForm from '../components/RSVPForm';
import Footer from '../components/Footer';

export const Home = () => {
  return (
    <div className="wedding-site">
      <HeroSection />
      <Welcome />
      <OurStory />
      <WeddingDetails />
      <Gallery />
      <Program />
      <RSVPForm />
      <Footer />
    </div>
  );
};

export default Home;
